export enum EMetaTagType {
    OG = "og",
    META = "meta",
    CUSTOM = "custom"
}
